var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g(_vm._b({staticClass:"add-button text-white bg-primary rounded-md"},'BaseButton',_vm.$attrs,false),_vm.$listeners),[_vm._v(" Add ")])
}
var staticRenderFns = []

export { render, staticRenderFns }